module.exports = __webpack_public_path__ + "img/traxion-1.43da4a60.png";